import React, { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router';

import { PieChartOutlined, DiffOutlined, UsergroupAddOutlined, NotificationOutlined, OrderedListOutlined, DashboardOutlined } from '@ant-design/icons';
import {  Divider, Menu, Select, Spin, Typography } from 'antd';

import { Context } from '../helpers/Context';
import BetaBadge from './BetaBadge';

//costruzione del singolo elemento di menù
function getItem(label, key, icon, className, children) {
  return {
    key,
    icon,
    children,
    label,
    className
  };
}


//elementi del menu e del menu secondario


function DashboardMenu({hideShops}) {

  const [disableMarketing, setDisableMarketing] = useState(false); 
  const [path] = useState(window.location.pathname);
  const [activeKey, setActiveKey] = useState("");

  const navigate = useNavigate();

  const {
    serviceNotification,
    shopsListLoading,
    isRestaurant,
    setShopName,
    shopsList,
    appToken,
    shopName,
    setShop,
    setOpen,
    shop,
  } = useContext(Context);


  // ------------- definisco i menu della navigazione ------------- 
  const primaryMenu =
    [
      getItem("Rapide", 'fast-stats', <DashboardOutlined />),
      getItem('Grafici', 'graphics', <PieChartOutlined />),
      getItem('Tabelle', 'tabulations', <OrderedListOutlined />),
      getItem("Confronta", 'compare', <DiffOutlined />),
    ];
  
  const marketingMenu = 
      [
      getItem('Pubblico', 'marketing/audiences', <UsergroupAddOutlined />),
      getItem('Operazioni', 'marketing/marketing-operations', <NotificationOutlined />),
    ];
  // ------------- definisco i menu della navigazione ------------- 
 
  function clickItem(e){ 
    navigate("/" + e.key);
  };

  useEffect(() => {
    const activePath = path.substring(1);
    setActiveKey(activePath === "" ? "fast-stats" : activePath)
  }, [path])

  useEffect(() => {
    
    const tokensEnabledList = [
      "8jx81yUyILOzuANR0eo0EQVvmKxm2XRJmO0F8kVx",
      "KPMzrR1mpZSf1DQRWt2ElUSKUONw6VJtf7qCMGk1", 
      "Ht9tRu6PvkvsYFZ3Fq7sGt6dxtc4r5yrX0U4e1Yq",
      "znrbhNXH7EAZR3Ft0DhDmnG77orr1l6bKCoPkfzY",
      "xJY9gXWBxe35W2Vba2cBATKtuNateIJ6mC4qI39a",

      "U7fB7w5ZIWGE0yq8IwsXKbXCwlRWmzPYGMK2q06w",
      "h5fPEYo12ghzhsZFnALAR0GPfqNeXmiBblAAo4Yy",
      "fR3oiNC96pWzQOai3OBlEUSesXIozMLVycwSlpjX",
      "8jx81yUyILOzuANR0eo0EQVvmKxm2XRJmO0F8kV"
    ]
    
    if (tokensEnabledList.includes(appToken)) {
      setDisableMarketing(false);
    } else {
      setDisableMarketing(true);
    }
  }, [appToken]);

  

  /////////////////////////////////////////////////////////////////////////////////////////// 
          //////////////////// azioni con la gestione filtri locale ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////

  const onClear = () => {
    setShop("");
    setShopName("");
    setOpen(false);
  }

  const onChange = (value, i) => {
    if (!i) return;
    
    setShopName(i.label);
    setShop(value ?? "");
    setOpen(false);
    
    sessionStorage.setItem("__di_public_code_filter", value)

  }


  /////////////////////////////////////////////////////////////////////////////////////////// 
          //////////////////// azioni con la gestione filtri locale ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className='di-navigation-menu-wrapper'>
      <div className='mt-10'>
        <Typography>Statistiche</Typography>
      </div>
      {/*-------------  menu principale -------------*/}
      <Menu className="di-navigation primary mt-5" theme="light" selectedKeys={activeKey} mode="inline" items={primaryMenu} onClick={clickItem}/>
      {/*-------------  menu principale -------------*/}

      {/*------------- marketing divider -------------*/}
      <div className='mt-10 relative'>
        <Typography>
          Marketing
          <BetaBadge text={"Alpha"}/>
        </Typography>
      </div>
      {/*------------- marketing divider ------------- */}

      {/*------------- menu secondario -------------*/}
      <Menu disabled={disableMarketing} className="di-navigation primary mt-5" theme="light" selectedKeys={activeKey} mode="inline" items={marketingMenu} onClick={clickItem}/>
      {/*------------- menu secondario -------------*/}

      
      {!hideShops &&
        <>
          <Divider />
          <div className='secondary-menu'>
            {/* filtri per cambiare statistiche rapide sull'ora corrente o tutto il giorno precedente */}
                <Divider >
                  <span className='m-2'>{`Filtra per ${!isRestaurant ? "Negozio" : "Ristorante "}`}</span>
                </Divider>
                <Spin spinning={shopsListLoading}>
                  <Select
                    showSearch
                    placeholder="Seleziona Negozio"
                    optionFilterProp="children"
                    className='w-100 min-w-150'
                    allowClear
                    value={shop}
                    onClear={onClear}
                    onChange={onChange}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={shopsList}
                  />
                </Spin>
                {/* filtri per cambiare statistiche rapide sull'ora corrente o tutto il giorno precedente */}
          </div>
        </>
      }
    </div>
  );
}

export default DashboardMenu;